import { BaseMapGroupControl } from '@/views/map/MapLayerManager/BaseMapGroupControl/BaseMapGroupControl';
import { BaseMapOption } from '@/views/map/MapLayerManager/BaseMapGroupControl/BaseMapOption/BaseMapOption';
import { useAppSelector, useAppDispatch } from '@/app/hooks';
import { update as updateMapLayerConfig } from '@/features/mapLayerSlice';
import type { BaseMapLayerConfig } from '@/views/map/layers/types';
import { LayerType } from '@/views/map/layers/types';
import { useUserClientContext } from '@/app/clientContext';

export const BaseMapControl = () => {
  const dispatch = useAppDispatch();
  const layerConfig = useAppSelector((s) => s.mapLayer);
  const { isInternalUser } = useUserClientContext();

  const enableCustomBaseMap = isInternalUser;
  const selected = layerConfig[LayerType.base].visible ? 'satellite' : 'base';
  const showLabels = (layerConfig[LayerType.base] as BaseMapLayerConfig)
    .showLabels;

  const updateBaseMap = (v: string) => {
    // Enable dark mode if base map is selected more than once.
    const darkMode = enableCustomBaseMap && selected === v && v === 'base';

    dispatch(
      updateMapLayerConfig({
        [LayerType.base]: {
          visible: v === 'satellite',
          darkMode,
          showLabels: !darkMode && showLabels,
        },
      })
    );
  };

  const toggleLabels = (v: boolean) => {
    dispatch(
      updateMapLayerConfig({
        [LayerType.base]: {
          visible: selected === 'satellite',
          darkMode: false,
          showLabels: v,
        },
      })
    );
  };

  return (
    <BaseMapGroupControl
      showLabels={showLabels}
      toggleLabels={toggleLabels}
      enableCustomBaseMap={enableCustomBaseMap}
      data-testid="base-map-control"
    >
      <BaseMapOption
        option="base"
        selected={selected}
        onChange={updateBaseMap}
      />
      <BaseMapOption
        option="satellite"
        selected={selected}
        onChange={updateBaseMap}
      />
    </BaseMapGroupControl>
  );
};
